import { useEffect, useState } from "react";
import { api, apiError } from "@/admin/api";
import { toast } from "sonner";

export default function Templates() {
  const [templates, setTemplates] = useState([]);
  const load = () => api.get("/admin/templates").then((r) => setTemplates(r.data));
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-serif text-3xl font-700 text-navy">Project templates</h1>
        <p className="text-sm text-mutedink">Default phases, durations and suggested payment milestones. All values remain editable per project.</p>
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {templates.map((t) => (
          <div key={t.id} className="rounded-xl border border-navy/10 bg-white p-5" data-testid={`template-${t.name.replace(/\s+/g,"-").toLowerCase()}`}>
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-serif text-xl font-600 text-navy">{t.name}</h3>
                <div className="text-xs text-mutedink">{t.project_type} · {t.phases.length} phases · {t.phases.reduce((a, p) => a + (p.duration_days || 0), 0)} days</div>
              </div>
            </div>
            <ul className="mt-4 space-y-1.5">
              {t.phases.map((p, i) => (
                <li key={i} className="flex items-center justify-between rounded-lg bg-cream px-3 py-2 text-sm">
                  <span className="text-navy">{i + 1}. {p.name}</span>
                  <span className="flex items-center gap-3 text-xs text-mutedink">
                    <span>{p.duration_days}d</span>
                    {p.payment_percentage ? <span className="rounded bg-gold/20 px-2 py-0.5 font-600 text-navy">{p.payment_percentage}%</span> : null}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
